export const USER_SESSION = {
    _id: '0',
    email: '',
    username: '',
    fullname: '', // nombre completo
    no_pwd: false, // cuenta sin contraseña
    platform: '',
    page: 'index'
};

export const USER_ADDRESS = {
    _id: '',
    name: '',
    lastname: '',
    tel: '',
    street: '',
    ext_num: '',
    int_num: '',
    crossing_streets: '',
    postalcode: '',
    colony: '',
    city: '',
    state: '',
    references: ''
};